import {gsap} from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

/**
 * Layout: Content slider
 * Slug: content_slider
 */


const initializeContentSlider = (layout) => {
		const imageSlider = layout.querySelector(
			".images-col .swiper-container",
		);
		const textSlider = layout.querySelector(
			".slider-col .swiper-container",
		);

		const navTotal = layout.querySelector(".swiper-navigation .total");
		const navCurrent = layout.querySelector(".swiper-navigation .current");

		const progress = layout.querySelector(".swiper-progress-bar");

		const slideCount = imageSlider.querySelectorAll(".swiper-slide").length;
		const imageSwiper = new Swiper(imageSlider, {
			slidesPerView: 1,
			spaceBetween: 16,
			loop: false,
			noSwiping: true,
			noSwipingClass: "swiper-no-swiping",
			effect: "creative",
			creativeEffect: {
				limitProgress: slideCount,
				prev: {
					translate: ["-10%", 0, 0],
					scale: 0,
					opacity: 0,
				},
				next: {
					scale: 1,
					opacity: 1,
					translate: ["-105%", 0, 0],
				},
			},
		});
		const textSwiper = new Swiper(textSlider, {
			slidesPerView: 1,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				crossFade: true,
			},
			controller: {
				control: imageSwiper,
			},
			navigation: {
				nextEl: layout.querySelector(".slider-button-next"),
				prevEl: layout.querySelector(".slider-button-prev"),
			},
			on: {
				slideChangeTransitionStart: (self) => {
					navCurrent.innerText = "0" + (self.realIndex + 1);
					const fraction = gsap.utils.clamp(
						5,
						100,
						self.progress * 100,
					);

					if (progress) {
						gsap.to(progress, {
							width: fraction + "%",
						});
					}
				},
			},
		});
		navTotal.innerText = "0" + textSwiper.slides.length;
};

const contentSliderSelector = ".flex-layout.content_slider-layout";
if (window.pkExperimentInit) {
	window.pkExperimentInit(contentSliderSelector, initializeContentSlider);
} else {
	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(contentSliderSelector).forEach(initializeContentSlider);
	});
}
